// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"controlPanel_panelWrapper__3c_2i","loadProducts":"controlPanel_loadProducts__21nCA","clearFilters":"controlPanel_clearFilters__3eCWk"};